import React from 'react'
import {css} from '@emotion/core'
import AboutFaqItem from './AboutFaqItem'

const aboutUsTranslations = require('../../translations/aboutUs.json')

const SUPPORT_ARTICLE_PATH = '/articles/4455540212116-The-Anonymous-View-proxy-technical-details'
const StaticSquiggle3 = ({className}) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="404"
        height="244"
        viewBox="0 0 404 244"
        fill="none"
    >
        <path
            d="M402.221 21.2707C402.221 21.2707 338 -21.6963 263.534 19.0532C227.854 38.5784 223.617 80.886 225.362 115.676C226.775 143.857 245.76 178.634 230.615 210.889C209.137 256.629 160.82 240.999 137.255 231.328C93.8199 213.503 65.6562 162.518 18.226 139.58C-29.2042 116.642 -99.7688 186.682 -45.3865 237.555"
            stroke="#C5CBFF"
            strokeWidth="3"
            strokeLinecap="round"
        />
    </svg>
)

const AboutSubsection3 = ({themeStyles, lang}) => {
    const localizations = aboutUsTranslations[lang]
    const {heading4, subtag3, faq, tagline4} = localizations
    const supportLocale = lang === 'de' || lang === 'nl' ? lang : 'en-us'
    const supportUrl = `https://support.startpage.com/hc/${supportLocale}${SUPPORT_ARTICLE_PATH}`
    const ctaLinkMatch = tagline4?.match(/<ctaLink>(.*?)<\/ctaLink>/)
    const taglineParts = ctaLinkMatch ? tagline4.split(/<ctaLink>.*?<\/ctaLink>/) : [tagline4]
    const ctaLinkLabel = ctaLinkMatch?.[1]
    return (
        <div
            css={css`
                background: ${themeStyles.about.subsection2BottomSquiggleFillColor};
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 20px 0 80px;
                position: relative;
                width: 100%;
                z-index: 1;
                @media (${themeStyles.breakPoints.mobile}) {
                    padding: 30px 0 0;
                }
            `}
        >
            <StaticSquiggle3
                css={css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 0;
                    pointer-events: none;
                    max-width: 456px;
                    width: 100%;
                    height: auto;
                    @media (${themeStyles.breakPoints.tabletSmall}) {
                        left: -70px;
                    }
                    @media (${themeStyles.breakPoints.mobile}) {
                        max-width: 175px;
                        top: 0;
                    }
                `}
            />
            <h2
                css={css`
                    font-size: 68px;
                    font-weight: 700;
                    color: ${themeStyles.about.valuePropTextColor};
                    margin-bottom: 39px;
                    line-height: 76px;
                    letter-spacing: -1.36px;
                    text-align: center;
                    padding: 0 32px;
                    @media (${themeStyles.breakPoints.mobile}) {
                        font-size: 48px;
                        line-height: 56px;
                        letter-spacing: -0.96px;
                    }
                `}
            >
                {heading4}
            </h2>
            <p
                css={css`
                    margin-bottom: 64px;
                    text-align: center;
                    font-size: 20px;
                    line-height: 28px;
                    padding: 0 32px;
                    color: ${themeStyles.about.valuePropTextColor};
                `}
            >
                {subtag3}
            </p>
            <div
                css={css`
                    max-width: 780px;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    padding: 0 24px;
                    margin-bottom: 32px;
                    z-index: 1;
                    @media (${themeStyles.breakPoints.mobile}) {
                        padding: 0 16px;
                    }
                `}
            >
                {faq.map((item, index) => (
                    <AboutFaqItem key={index} item={item} themeStyles={themeStyles} />
                ))}
            </div>
            <p
                css={css`
                    font-size: 14px;
                    line-height: 20px;
                    color: ${themeStyles.about.valuePropTextColor};
                    max-width: 484px;
                    width: 100%;
                    text-align: center;
                    @media (${themeStyles.breakPoints.mobile}) {
                        max-width: 304px;
                    }
                `}
            >
                {taglineParts[0]}
                {ctaLinkLabel ? (
                    <a
                        className="cta4"
                        href={supportUrl}
                        target="_blank"
                        rel="noreferrer noopener"
                        css={css`
                            color: ${themeStyles.about.cta4Color};
                            text-decoration: none;
                        `}
                    >
                        {ctaLinkLabel}
                    </a>
                ) : null}
                {taglineParts[1]}
            </p>
            <img
                src={themeStyles.about.shieldDude}
                alt="just a chill guy holding a shield"
                css={css`
                    position: absolute;
                    width: 185px;
                    bottom: -100px;
                    left: 100px;
                    @media (${themeStyles.breakPoints.desktopMedium}) {
                        left: 0;
                    }
                    @media (${themeStyles.breakPoints.tabletLarge}) {
                        display: none;
                    }
                    @media (${themeStyles.breakPoints.mobile}) {
                        display: block;
                        position: relative;
                        bottom: unset;
                        left: unset;
                        margin: 64px 0 -50px;
                        width: 150px;
                    }
                `}
            />
        </div>
    )
}

export default AboutSubsection3
